import React from "react";
import { App, Button, Tooltip } from "antd";
import { GoCodescanCheckmark } from "react-icons/go";
import { useSearchParams } from "react-router-dom";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const TableAction = ({ record }) => {
  // -------------------------- VAR -----------------------------
  // const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "not_edit";

  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleQC = () => {
    if (!record) return message.error("Data not found!");
    // const id = record?.bailiff;
    const slot = record?.slot;
    // const href = `/bailiff/${id}/${slot}`;
    // navigate(href, { replace: true });
    const params = {
      tab,
      slot,
    };

    setSearchParams(params);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Tooltip title="QC trích đoạn này">
      <Button
        onClick={handleQC}
        icon={
          <span className="anticon">
            <GoCodescanCheckmark />
          </span>
        }
      />
    </Tooltip>
  );
};
export default TableAction;
